import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const FileUploadIcon = {
  name: 'FileUploadIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "5 0 38 34.4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "1px",
        "stroke-miterlimit": "10"
      },
      "class": "feather feather-file-download"
    }, ctx.data]), [
      h("path", {
        attrs: {
          d: "M31.427,31.318H12.673c-1.195,0-2.164-.968-2.165-2.163,0,0,0,0,0-.001V5.247c0-1.195.969-2.164,2.164-2.164,0,0,0,0,0,0h11.725c.583,0,1.141.235,1.548.651l7.029,7.188c.395.405.616.948.616,1.514v16.718c0,1.195-.969,2.164-2.164,2.164h0"
        }
      }),
      h("path", {
        attrs: {
          d: "M25.143,3.464l-.035,6.991c-.003.721.579,1.309,1.3,1.312.002,0,.004,0,.006,0h6.894c.065,0,.117-.053.117-.117,0-.031-.013-.061-.035-.083L25.262,3.415c-.028-.027-.072-.027-.099,0-.013.013-.02.03-.02.048"
        }
      }),
      h("path", {
        attrs: {
          d: "M27.462,21.483v2.3c0,.374-.303.677-.677.677h-9.608c-.374,0-.677-.303-.677-.677h0v-2.3"
        }
      }),
      h("path", {
        attrs: {
          d: "M24.795,16.351l-2.607-2.8c-.107-.114-.286-.121-.4-.014-.005.005-.01.009-.014.014l-2.607,2.8",
          "stroke-linecap": "round"
        }
      }),
      h("line", {
        attrs: {
          x1: "21.981",
          y1: "21.485",
          x2: "21.981",
          y2: "13.552",
          "stroke-linecap": "round"
        }
      })
    ]);
  }
};

export default FileUploadIcon;